import React from 'react';

import { Checkin } from '~/components/layouts/Checkin';
import { Entry } from '~/components/pages/Checkin_Entry';

const CheckinEntry = () => (
  <Checkin>
    <Entry />
  </Checkin>
);

export default CheckinEntry;
